/** @jsx jsx */
import { jsx } from "theme-ui"
import { graphql, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { RiArrowRightSLine } from "react-icons/ri"

import Layout from "../components/layout"
import BlogListHome from "../components/blog-list-home"
import Seo from "../components/seo"
import horizontal from '../../static/assets/wsb_horizontal_logo.png'

export const pageQuery = graphql`
  query HomeQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        title
        tagline
        middleImage {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, width: 600 height: 449)
          }
        }
        rightImage {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, width: 300 height: 449)
          }
        }
        leftImage {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, width: 300 height: 449)
          }
        }
        cta {
          ctaText
          ctaLink
        }
      }
    }
    posts: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: { template: { eq: "blog-post" } } }
      limit: 6
    ) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            slug
            title
            featuredImage {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, width: 345, height: 260)
              }
            }
          }
        }
      }
    }
  }
`

const HomePage = ({ data }) => {
  const { markdownRemark, posts } = data // data.markdownRemark holds your post data
  const { frontmatter, html } = markdownRemark

  const middleImage = frontmatter.middleImage
    ? frontmatter.middleImage.childImageSharp.gatsbyImageData
    : ""

  const rightImage = frontmatter.rightImage
    ? frontmatter.rightImage.childImageSharp.gatsbyImageData
    : ""

  const leftImage = frontmatter.leftImage
    ? frontmatter.leftImage.childImageSharp.gatsbyImageData
    : ""

  
  return (
    <Layout>
      <Seo />
      <img src={horizontal} alt='' style={{width: '90%', display: 'block', margin: 'auto'}}/>
      <p
        className="tagline"
        sx={{
              color: "muted",
              textAlign: 'center',
              fontStyle: 'italic',
              fontSize: '2vw',
              textTransform: 'capitalize',
            }}
      >
        {frontmatter.tagline}
      </p>
      <div className='home-banner'>
        <div className='image-container' sx={{ width: '25%'}}>
            <GatsbyImage
              image={leftImage}
              alt={frontmatter.title + " - Left image"}
              className="featured-image"
            />
        </div>
        <div className='image-container' sx={{ width: '50%'}}>
            <GatsbyImage
              image={middleImage}
              alt={frontmatter.title + " - Middle image"}
              className="featured-image"
              sx={{maxWidth: '100%'}}
            />
        </div>
        <div className='image-container' sx={{ width: '25%'}}>
            <GatsbyImage
              image={rightImage}
              alt={frontmatter.title + " - Right image"}
              className="featured-image"
            />
        </div>
      </div>
      <div sx={{ textAlign: 'center' }}>
        <h1 className="title">{frontmatter.title}</h1>
        
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: html }}
        />
        <br />
        <Link
          to={frontmatter.cta.ctaLink}
          className="button"
          sx={{
            variant: "variants.button",
          }}
        >
          {frontmatter.cta.ctaText}
          <span className="icon -right">
            <RiArrowRightSLine />
          </span>
        </Link>
      </div>
      <br />
      <br />
      
      <BlogListHome data={posts} />
    </Layout>
  )
}

export default HomePage
